import React from 'react';
import clsx from 'clsx';
import Navigation from './VerticleNav';
import PropTypes from 'prop-types';
import useStyles from './AppSidebar.style';
import {connect, setStore} from "trim-redux";
import {Box, Drawer, Fab, Hidden} from "@mui/material";
import {Menu,X} from "lucide-react";

const AppSidebar = (props) => {

    const navCollapsed = props.navCollapsed;
    const classes = useStyles();
    let sidebarClasses = classes.sidebarStandard;


    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor={props.position}
                    open={navCollapsed}
                    onClose={(ev) => setStore({navCollapsed:!props.navCollapsed})}
                    style={{position: 'absolute'}}>
                    <Box height='100%' className={classes.drawerContainer}>
                        <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
                            <Navigation />
                        </Box>
                    </Box>
                </Drawer>
                <Fab
                    color="primary"
                    size="small"
                    style={{position:"fixed",bottom:70,left:20,zIndex:1200}}
                    onClick={() => setStore({navCollapsed:!props.navCollapsed})}
                >
                    {
                        !!props.navCollapsed ? <X/> : <Menu/>
                    }

                </Fab>
            </Hidden>
            <Hidden lgDown>
                <Box height='100%' className={classes.drawerContainer}>
                    <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
                        <Navigation />
                    </Box>
                </Box>
            </Hidden>
        </>
    );
};

const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo:state.logo
});
export default connect(mstp)(AppSidebar);

AppSidebar.defaultProps = {
    variant: '',
    position: 'left',
};

AppSidebar.propTypes = {
    position: PropTypes.string,
    variant: PropTypes.string,
};
